import { Observable, Subject } from "rxjs";

import { Closable } from "./closable";
import { OverlayRef } from "./overlay-ref";
import { closeSymbol, instanceSymbol } from "./symbols";

export class ModalRef<T = any, R = any> {
	private onClosed = new Subject<unknown>();
	private componentInstance: T;

	constructor(
		private overlayRef: OverlayRef,
		private service: Closable,
	) {}

	set [instanceSymbol](instance: T) {
		this.componentInstance = instance;
	}

	get instance() {
		return this.componentInstance;
	}

	close(result?: any) {
		this.service[closeSymbol]();
		this.onClosed.next(result);
		this.onClosed.complete();
	}

	afterClosed() {
		return this.onClosed.asObservable() as Observable<R>;
	}

	backdropClick() {
		return this.overlayRef.backdropClick$;
	}
}
